// Shared, slice-agnostic derivations of a `productConfigInfo` blob (the flat
// {centers, apps, oneTimeFees} catalog fetched once from plans/5/v1/list).
// Both ProposalSlice and PurchaseLinkSlice fetch/store their own copy of
// productConfigInfo, but the grouping/loaded-check logic is identical — this
// factory lets each slice build its own memoized selectors from its own
// `selectProductConfigInfo` without duplicating the derivation.
import {createSelector} from '@reduxjs/toolkit'
import {transformProducts} from '../../features/CatalogGrid/utils/transformProducts'

export function makeProductGroupSelectors(selectProductConfigInfo) {
  const selectProductGroups = createSelector(
    [selectProductConfigInfo],
    productConfigInfo => transformProducts(productConfigInfo),
  )

  const selectSoftwareGroups = createSelector([selectProductGroups], groups =>
    groups.filter(group => group.prod_type === 'Center'),
  )

  const selectAddonGroups = createSelector([selectProductGroups], groups =>
    groups.filter(
      group => group.prod_type === 'App' || group.prod_type === 'OneTimeFees',
    ),
  )

  const selectIsCatalogDataLoaded = createSelector(
    [selectProductConfigInfo],
    productConfigInfo =>
      'centers' in productConfigInfo || 'apps' in productConfigInfo,
  )

  return {
    selectProductGroups,
    selectSoftwareGroups,
    selectAddonGroups,
    selectIsCatalogDataLoaded,
  }
}
